<template>
<div>
    <v-toolbar flat color="white" pt-4 mt-4>
        <v-btn round color="primary" @click="addOrganisationTypeModal=true">
            Add Organisation Type
        </v-btn>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="organisationtypes"
        item-key="id"
        align-center
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon v-if="props.item.isEditable" small @click="editItem(props.item)">edit</v-icon>
            <v-icon v-if="props.item.isEditable" small @click="deleteItem(props.item)">delete</v-icon>
          </td>

          <td class="text-xs-center">{{props.item.name}}</td>
           <td class="text-xs-center">{{props.item.description}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

      <v-dialog v-model="addOrganisationTypeModal" max-width="750px">
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">ADD ORGANISATION TYPE</h1></v-toolbar>
              <v-card-text>
                  <v-text-field label="Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Description" v-model="item.description"></v-text-field>
              </v-card-text>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="addOrganisationTypeModal=false">Cancel</v-btn>
                      <v-btn round color="primary" @click="saveOrganisationType">Save</v-btn>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>

      <v-dialog v-model="editOrganisationTypeModal" max-width="750px">
        <v-card flat color="white">
          <v-toolbar color="primary"><h1 class="headline white--text">EDIT ORGANISATION TYPE: {{item.name}}</h1></v-toolbar>
          <v-card-text>
                  <v-text-field label="Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Description" v-model="item.description"></v-text-field>
              </v-card-text>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="editOrganisationTypeModal=false">Cancel</v-btn>
                      <v-btn round color="primary" @click="saveEditedOrganisationType">Save</v-btn>
                  </v-layout>
              </v-card-actions>

        </v-card>
        

      </v-dialog>
</div>
  
</template>

<script>
import Api from "@/services/Api";
export default {
    props: ['organisationtypes'],
    data(){
        return {
            addOrganisationTypeModal:false,
            item: {},
            editOrganisationTypeModal: false,
            headers: [
                {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }]
        }
    },
    methods: {
        deleteItem(item){
            Api()
            .put('/organisationType/'+item.id,{
                isActive: false,
                isDeleted: true
            }).then(this.$emit('organisationTypeChange'))
        },
        editItem(item){
            this.item = Object.assign({}, item);
            this.editOrganisationTypeModal=true
        },
        saveEditedOrganisationType(){
            Api()
            .put('/organisationType/'+this.item.id,{
                name: this.item.name,
                description: this.item.description,
                isActive: true,
                isDelete: false
            }).then(this.editOrganisationTypeModal=false, this.item={}, this.$emit('organisationTypeChange'))
        },
        saveOrganisationType(){
            Api()
            .post('/organisationType',{
                name: this.item.name,
                description: this.item.description,
                isActive: true,
                isDelete: false
            }).then(this.addOrganisationTypeModal=false, this.item={}, this.$emit('organisationTypeChange'))
        }
    }

}
</script>

<style>

</style>